import React, { useCallback } from "react"; 
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IntakeFormRes } from "../patients/index.type";

const useFetchCarePlan = ({ templateId, patientId }: { templateId: string; patientId?: string }) => {
  const [carePlan, setCarePlan] = React.useState<IntakeFormRes>();

  const { loading: carePlanLoading, makeApiCall } = useApi({
    url: patientId 
      ? `/rtm/template/question/${templateId}/${patientId}`
      : `/rtm/template/question/${templateId}`,
    method: "GET",
  });

  const getCarePlan = useCallback(async () => {
    if (!templateId) return;


    const { response } = await makeApiCall<undefined, IntakeFormRes>();

    if (response?.status === "success") {
      setCarePlan(response);
    } else {
      setCarePlan(undefined);
      toast.error(
        "Something went wrong while fetching intake form. Please try again later"
      );
    }
  }, [makeApiCall, templateId]); 

  return {
    carePlan,
    getCarePlan,
    carePlanLoading,
  };
};

export default useFetchCarePlan ;